<span class="weekly-state-label" [ngClass]="styleClass">{{ label }}</span>
